import { useEffect, useState } from "react";
import { api } from "../api/client";

// Admin (2026-10-28): searches whose link is ONE listing, not a search — they never bring new listings.
// Shown on top of «Активные поиски»; the owner can be sent a hint how to put a search link instead.
function when(v: string | null) {
  if (!v) return "";
  return new Date(v).toLocaleString("ru-RU", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
}

const STATUS: Record<string, string> = { ACTIVE: "работает", PAUSED: "на паузе", EXPIRED: "истёк", STOPPED: "остановлен" };

export default function ItemLinksBox() {
  const [items, setItems] = useState<any[] | null>(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const load = () => api.get("/admin/item-links").then((r: any) => setItems(r.data.items || [])).catch(() => setItems([]));
  useEffect(() => {
    load();
  }, []);

  const hint = async (ids: number[]) => {
    if (ids.length === 0) return;
    setBusy(true);
    setMsg("Отправляю…");
    try {
      const r: any = await api.post("/admin/item-links/hint", { ids });
      setMsg(`Отправлено: ${r.data.sent}${r.data.failed ? `, не доставлено: ${r.data.failed}` : ""}`);
      await load();
    } catch {
      setMsg("Не получилось отправить");
    } finally {
      setBusy(false);
    }
  };

  const pause = async (s: any) => {
    if (!window.confirm(`Поставить на паузу «${s.name}»?`)) return;
    try {
      await api.post(`/admin/searches/${s.id}/status`, { status: "PAUSED" });
      setMsg(`«${s.name}» на паузе`);
      await load();
    } catch {
      setMsg("Не получилось поставить на паузу");
    }
  };

  if (!items || items.length === 0) return null;
  const pending = items.filter((s) => !s.hint_sent_at && !s.is_admin && s.status === "ACTIVE").map((s) => s.id);
  return (
    <div style={styles.box}>
      <div style={styles.title}>🔗 Ссылка на объявление, а не на поиск — {items.length}</div>
      <div style={styles.hint}>По такой ссылке новые объявления не приходят. Владельцу можно отправить подсказку, как поставить ссылку на поиск.</div>
      {items.map((s) => (
        <div key={s.id} style={styles.row}>
          <div style={{ minWidth: 0, flex: 1 }}>
            <a href={s.url} target="_blank" rel="noopener noreferrer" style={styles.name}>#{s.id} {s.name}</a>
            <div style={styles.hint}>
              <a href={s.username ? `https://t.me/${s.username}` : `tg://user?id=${s.telegram_id}`} target="_blank" rel="noopener noreferrer" style={styles.link}>
                {s.is_admin ? "вы" : s.username ? `@${s.username}` : s.first_name || `TG: ${s.telegram_id}`}
              </a> · {STATUS[s.status] || s.status}
              {s.hint_sent_at ? ` · подсказка ${when(s.hint_sent_at)}` : ""}
            </div>
          </div>
          {!s.is_admin && (
            <button style={s.hint_sent_at ? styles.ghostBtn : styles.btn} disabled={busy} onClick={() => hint([s.id])}>
              {s.hint_sent_at ? "Ещё раз" : "📩 Подсказка"}
            </button>
          )}
          {s.status === "ACTIVE" && <button style={styles.ghostBtn} disabled={busy} onClick={() => pause(s)}>⏸</button>}
        </div>
      ))}
      {pending.length > 1 && (
        <button style={{ ...styles.btn, width: "100%", marginTop: "8px" }} disabled={busy} onClick={() => hint(pending)}>
          📩 Отправить подсказку всем работающим без неё ({pending.length})
        </button>
      )}
      {msg && <div style={{ ...styles.hint, marginTop: "6px", fontWeight: 600 }}>{msg}</div>}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  box: { backgroundColor: "var(--tg-theme-secondary-bg-color, #fff)", borderRadius: "12px", padding: "12px", margin: "0 0 12px 0", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", border: "1px solid rgba(245,158,11,0.5)" },
  title: { fontSize: "14px", fontWeight: 700, color: "var(--tg-theme-text-color, #000)", marginBottom: "4px" },
  hint: { fontSize: "12px", color: "var(--tg-theme-hint-color, #666)" },
  row: { display: "flex", alignItems: "center", gap: "8px", padding: "8px 0", borderBottom: "1px solid rgba(127,127,127,0.12)" },
  name: { fontSize: "13px", fontWeight: 600, color: "var(--tg-theme-text-color, #000)", textDecoration: "none", wordBreak: "break-word" },
  link: { color: "var(--tg-theme-link-color, #2481cc)", textDecoration: "none" },
  btn: { padding: "7px 10px", borderRadius: "8px", border: "none", backgroundColor: "var(--tg-theme-button-color, #2481cc)", color: "var(--tg-theme-button-text-color, #fff)", fontSize: "12px", cursor: "pointer", flexShrink: 0 },
  ghostBtn: { padding: "7px 10px", borderRadius: "8px", border: "1px solid rgba(127,127,127,0.3)", backgroundColor: "transparent", color: "var(--tg-theme-text-color, #000)", fontSize: "12px", cursor: "pointer", flexShrink: 0 },
};
